import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from './authContext'

/** Canonical auth hook (CONTRACTS.md §2). Must be used inside AuthProvider. */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext)
  if (!value) {
    throw new Error('useAuth must be used within <AuthProvider>')
  }
  return value
}
